import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useChatStore } from 'Src/store/useChatStore';
import PracticeService from '../../../services/practice-service';

const useCreateOrUpdatePractice = () => {
  const queryClient = useQueryClient();
  const clearMessages = useChatStore((state) => state.clearMessages);

  return useMutation({
    mutationFn: (data: { id?: string; [key: string]: any }) => {
      if (data.id) {
        return PracticeService.updatePractices(data.id, data);
      }
      return PracticeService.createPractices(data);
    },
    onSuccess: () => {
      clearMessages();
      queryClient.invalidateQueries({ queryKey: ['practices'] });
      queryClient.invalidateQueries({ queryKey: ['posts'] });
    },
  });
};

export default useCreateOrUpdatePractice;
